import { createBrowserRouter, Navigate } from 'react-router-dom';
// project import
import AuthRoutes from './AuthRoutes';
import useExternalRedirect from '@assetron/web-common/hooks/useExternalRedirect';
import {
  EMPTY_STRING,
  RETURN_URL_QUERY_PARAM,
} from '@assetron/common/constants/constant';
import useConfig from '@assetron/common/hooks/useConfig';
import Loader from '@assetron/web-common/components/common/Loader';
import { SIGN_IN_PATH } from '@assetron/common/api/constants/pathConstants';
import { QueryParamPersistence } from '@assetron/web-common/utils/queryParamPersistence';
import Cookie from 'js-cookie';
import { IS_USER_LOGGED_IN } from '@assetron/web-common/constants/LocalStorageConstants';

// ==============================|| ROUTING RENDER ||============================== //

function Router(isAuthenticated: boolean) {
  const { APP_URL } = useConfig();
  const hasCookieBackedLogin = Cookie.get(IS_USER_LOGGED_IN) === 'true';
  const shouldStayOnAuthRoute = !isAuthenticated || !hasCookieBackedLogin;

  const urlParams = new URLSearchParams(globalThis.location.search);
  const returnUrlFromParams = urlParams.get(RETURN_URL_QUERY_PARAM);
  const returnUrl = returnUrlFromParams ?? APP_URL;
  useExternalRedirect(shouldStayOnAuthRoute, returnUrl, EMPTY_STRING);

  const signInPath = QueryParamPersistence.addPersistedParamsToPath(
    `/${SIGN_IN_PATH}`,
  );

  return createBrowserRouter(
    [
      {
        path: '/',
        children: [
          {
            index: true,
            element: isAuthenticated && hasCookieBackedLogin ? (
              <Loader />
            ) : (
              <Navigate to={signInPath} />
            ),
          },
        ],
      },
      AuthRoutes(isAuthenticated),
      {
        path: '*',
        element: <Navigate to={signInPath} />,
      },
    ],
    { basename: import.meta.env.VITE_APP_BASE_NAME },
  );
}

export default Router;
